var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"login-text-input",class:{ '-error': _vm.errors.has(_vm.name) },on:{"click":_vm.clickHandler}},[_c('div',{staticClass:"login-input-row"},[_c('div',{staticClass:"login-input-label",class:{
                '-filled': _vm.value || _vm.value === 0,
                '-error': _vm.errors.has(_vm.name)
            },domProps:{"textContent":_vm._s(_vm.$t(_vm.label))}}),_c('DatePicker',{staticStyle:{"margin-left":"-1rem"},attrs:{"value":_vm.value,"border":false},on:{"input":_vm.dateSelected}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }